import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import React from "react";
import { Alaap_dev, CMS_maati } from "urlconfig";
import { OliveFirstLevelData } from "./OliveFirstLevelData";
import { selectLanguage } from "features/auth/authSlice";
import { useSelector } from "react-redux";
import OliveLocationFilters from "./OliveLocationFilters";
import useDebouncedValue from "hooks/useDebouncedValue";

export const OliveBaselineAssessment = ({ orgName, firstDistrict }) => {
  const language = useSelector(selectLanguage);
  const [ids, setIds] = useState([]);
  const [labelData, setLabelData] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  const debouncedSearch = useDebouncedValue(searchKey);
  const [filters, setFilters] = useState({
    level2: null,
    level3: null,
    level4: null,
  });

  const handleLocationChange = (newFilters) => {
    setFilters(newFilters);
  };

  useEffect(() => {
    let filteredData = [];
    fetch(
      `${Alaap_dev}/api/alaap-ui-schemas?filters[form_name]=respondent_Information`
    )
      .then((res) => res.json())
      .then((data) => {
        // console.log("data", data?.data);
        if (language === "pt-PT")
          filteredData = data?.data?.find((item) => item.language === "pt");
        else filteredData = data?.data?.find((item) => item.language === "en");
        setLabelData(filteredData?.labels?.form_data?.components || []);
      });
  }, [language]);
  // console.log("labelData",labelData)

  //   const optionCrop = React.useMemo(() => {
  //     if (!CropListMaster) return [];

  //     const groups = CropListMaster?.reduce((acc, crop) => {
  //       const groupName = crop.crop_group || "Others";
  //       if (!acc[groupName]) acc[groupName] = [];
  //       acc[groupName].push({
  //         label: crop.crop_name,
  //         value: crop.crop_name,
  //       });
  //       return acc;
  //     }, {});

  //     return Object.keys(groups).map((group) => ({
  //       label: group,
  //       options: groups[group],
  //     }));
  //   }, [CropListMaster]);

  //   useEffect(() => {
  //     if (!CropLabel) return;

  //     fetch(
  //       `${CMS_maati}/api/farmer-crop-level-1s?filters[farmer_crop_level_1][$containsi]=${CropLabel}&fields[1]=farmerId&sort[0]=createdAt:desc&pagination[page]=1&pagination[pageSize]=100`
  //     ).then((res) =>
  //       res.json().then((data) => setIds(data?.data?.map((d) => d.farmerId)))
  //     );
  //   }, [CropLabel]);

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "38px",
      height: "38px",
      fontSize: "13px",
      zIndex: 100,
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 3000,
    }),
  };

  return (
    <div className="p-0 mb-5">
      <Row className="mt-3 align-items-center position-relative d-flex flex-column flex-lg-row">
        <Col xs="12" lg="9" className="mb-2 mb-lg-0">
          <OliveLocationFilters
            onChange={handleLocationChange}
            firstDistrict={firstDistrict}
          />
        </Col>

        {/* <Col xs="12" lg="3" className="mb-2">
            <Select
              value={
                CropCode && CropLabel
                  ? { value: CropCode, label: CropLabel }
                  : null
              }
              onChange={(option) => {
                if (option) {
                  setCropCode(option.value);
                  setCropLabel(option.label);
                } else {
                  setCropCode(null);
                  setCropLabel(null);
                }
              }}
              options={optionCrop}
              placeholder="Select Crop"
              styles={customStyles}
              isClearable
            />
          </Col>

          <div className="text-end ">
            <span
              style={{
                color: "steelblue",
                textDecoration: "underline",
                cursor: "pointer",
                position: "absolute",
                top: "-25px",
                right: "10px",
              }}
              onClick={() => {
                setActiveCard(null);
                setFilters({
                  district: null,
                  block: null,
                  grampanchayat: null,
                  majra: null,
                });
                setCropCode(null);
                setCropLabel(null);
                setIds([]);
              }}
            >
              Back
            </span>
          </div> */}
      </Row>

      <OliveFirstLevelData
        ids={ids}
        filters={filters}
        labelData={labelData}
        language={language}
      />
    </div>
  );
};
